<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <object :data="pdf" type="application/pdf" style="width:100%;height:75vh;"></object>
  </div>
</template>

<script>
export default {
  inject: ['dialogRef'],
  components: {},
  data() {
    return {
      loaded: false,
      pdf: this.dialogRef.data.pdf,
    };
  },
  computed: {},
  methods: {
    mt_start() {
      this.loaded = true;
      this.mt_isMobile();
    },
    mt_isMobile() {
      if (!this.fc_isMobile()) {
        this.loaded = true;
      } else {
        window.open(this.pdf, '_blank', 'noreferrer');
        this.dialogRef.close();
      }
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<style scoped>

</style>
